export const bathrooms = [
  {
    id: "0001",
    name: "Projecto 01",
    highlight: `/assets/bathroom/0001/04.jpeg`,
    assets: [
      `/assets/bathroom/0001/01.jpeg`,
      `/assets/bathroom/0001/02.jpeg`,
      `/assets/bathroom/0001/03.jpeg`,
      `/assets/bathroom/0001/04.jpeg`,
    ],
  },
];
